import { Koi } from '@ksyos/koi';
import type { ISchemaContainer } from './schemaContainer';
import { CareProductType } from '../enums/careProductType';
import { positiveInt32Schema } from './schemas/positiveInt32Schema';

export interface IInsurerTurnoverCeilingAddEditValidated {
    careProductType: CareProductType | null;
    ceilingAmount: number;
    insurerId: string;
    year: number;
}

const insurerTurnoverCeilingEdit = Koi.object({
    careProductType: Koi.koi().enum(CareProductType).allow(null),
    ceilingAmount: positiveInt32Schema,
    year: positiveInt32Schema,
}).options({ convert: false, presence: 'required' });

export const insurerTurnoverCeilingEditSchema: ISchemaContainer<IInsurerTurnoverCeilingAddEditValidated> = {
    schema: insurerTurnoverCeilingEdit,
};

export const insurerTurnoverCeilingAddSchema: ISchemaContainer<IInsurerTurnoverCeilingAddEditValidated> = {
    schema: insurerTurnoverCeilingEdit.concat(
        Koi.object({
            insurerId: Koi.string().uuid(),
        }).options({ convert: false, presence: 'required' })
    ),
};
